import { Component, Input, OnInit, inject } from '@angular/core';
import { AuthService } from '../../../../core/authentication/auth.service';
import { Permission } from 'src/app/common/enums/permissions';
import { WorkerService } from 'src/app/data/worker.service';
import { finalize, first } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-navbar-user-menu',
  templateUrl: './navbar-user-menu.component.html',
  styleUrls: ['./navbar-user-menu.component.scss'],
  standalone: false
})
export class NavbarUserMenuComponent implements OnInit {
  private readonly authService = inject(AuthService);
  private readonly workerService = inject(WorkerService);
  private spinner = inject(NgxSpinnerService);
  private router = inject(Router);

  @Input() firstName: string;
  @Input() lastName: string;
  @Input() lastLoginDate: Date;
  @Input() lastFailedLogonAttemptDate: Date;
  public workerId: number;

  constructor() { }

  async ngOnInit(): Promise<void> {
    await firstValueFrom(this.authService.userData$.pipe(first(user => !!user?.userData)));

    if (!this.authService.hasPermission(Permission.ManageAsAExternalWorker)) {
      return;
    }

    this.spinner.show();
    this.workerService
      .getWorkerIdByAuthServerUserId(this.authService.authServerUserId)
      .pipe(
        first(),
        finalize(() => this.spinner.hide()),
      )
      .subscribe((id) => {
        this.workerId = id;
      });
  }

  async signout() {
    await this.authService.signout();
  }

  redirectTo(uri: any, expternalWorkerId: number): void {
    if (expternalWorkerId) {
      this.router.navigateByUrl(`/refresh`, { skipLocationChange: true }).then(() => this.router.navigate(uri));
      return;
    }
    this.router.navigateByUrl(`workerAgreements`);
  }
}
